import React from 'react';

export const SearchLoader: React.FC = () => {
    return (
        <div className="search-loader">
            <div className="search-loader__spinner"></div>
            <div className="search-loader__text">Searching...</div>
        </div>
    );
};

